module.exports = __webpack_public_path__ + "img/abnormal_icon_heart_h.b638afa6.png";